import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { LocationContext } from "../context/LocationContext";
import MainLayout from "../layouts/MainLayout";
import Home from "../pages/Home";
import About from "../pages/About";
import Blog from "../pages/Blog";
import BlogDetails from "../pages/BlogDetails";
import Cart from "../pages/Cart";
import Contact from "../pages/Contact";
import Signin from "../pages/Signin";
import Address from "../pages/Address";
import Profile from "../pages/Profile";
import MyOrder from "../pages/MyOrder";   
import Menu from "../pages/Menu";
import ProductDetails from "../pages/ProductDetails";
import Support from "../pages/Support";
import FooterLayout from "../layouts/FooterLayout";
import Partner from "../pages/Partner";
import RequireAuth from "../Private/Requiredau";
import SEOUpdater from "../components/SEOUpdater";
import ScrollToTop from "../components/ScrollToTop";
import NotFound from "../pages/NotFound";
import CategoryView from "../pages/CategoryView";
import Faq from "../pages/Faq";
import Earning from "../pages/Earning";
import OrderDetails from "../pages/OrderDetails";
import OrderSuccess from "../pages/OrderSuccess";

const AppRouter = () => {
    const { location } = useContext(LocationContext);

    return (
        <>
            <SEOUpdater />
            <ScrollToTop />
            <Routes>
                {/* Routes with header/footer (MainLayout) */}
                <Route element={<MainLayout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={location ? <About /> : <Navigate to="/" />} />
                    <Route path="/faq" element={location ? <Faq /> : <Navigate to="/" />} />
                    <Route path="/blog" element={location ? <Blog /> : <Navigate to="/" />} />
                    <Route path="/blog/:Id" element={location ? <BlogDetails /> : <Navigate to="/" />} />
                    <Route path="/contact-us" element={location ? <Contact /> : <Navigate to="/" />} />
                    <Route path="/cart" element={location ? <RequireAuth><Cart /></RequireAuth> : <Navigate to="/" />} />
                    <Route path="/sign-in" element={<Signin />} />
                    <Route path="/my-address" element={<RequireAuth><Address /></RequireAuth>} />
                    <Route path="/my-order" element={<RequireAuth><MyOrder /></RequireAuth>} />
                    <Route path="/order-details/:orderId" element={<RequireAuth><OrderDetails /></RequireAuth>} />
                    <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
                     <Route path="/order-success/:orderId" element={<RequireAuth><OrderSuccess /></RequireAuth>} />
                    <Route path="/menu" element={location ? <Menu /> : <Navigate to="/" />} />
                    <Route path="/product-view/:Id" element={location ? <ProductDetails /> : <Navigate to="/" />} />
                    <Route path="/category/:Id" element={location ? <CategoryView /> : <Navigate to="/" />} />
                </Route>

                <Route element={<FooterLayout />}>
                    <Route path="/support" element={<Support />} />
                    <Route path="/become-a-rotiey-maker" element={<Partner />} />
                    <Route path="/start-delivering-rotiey" element={<Earning />} />
                </Route>

                <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    );
};

export default AppRouter;


// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import MainLayout from "../layouts/MainLayout";
// import Home from "../pages/Home";
// import About from "../pages/About";
// import Blog from "../pages/Blog";
// import BlogDetails from "../pages/BlogDetails";
// import Cart from "../pages/Cart";
// import Contact from "../pages/Contact";
// import Signin from "../pages/Signin";
// import Address from "../pages/Address";
// import Profile from "../pages/Profile";
// import MyOrder from "../pages/MyOrder";
// import OrderTracking from "../pages/OrderTracking";
// import WishList from "../pages/WishList";
// import Checkout from "../pages/Checkout";
// import OrderAddress from "../pages/OrderAddress";
// import OrderConfirm from "../pages/OrderConfirm";
// import Payments from "../pages/Payments";
// import Menu from "../pages/Menu";
// import ProductDetails from "../pages/ProductDetails";
// import Support from "../pages/Support"; // new page
// import FooterLayout from "../layouts/FooterLayout";
// import Partner from "../pages/Partner";
// import RequireAuth from "../Private/Requiredau";
// import SEOUpdater from "../components/SEOUpdater";
// import ScrollToTop from "../components/ScrollToTop";
// import NotFound from "../pages/NotFound";

// const AppRouter = () => {
//     return (
//         <>
//             <SEOUpdater />
//             <ScrollToTop />
//             <Routes>
//                 {/* Routes with header/footer (MainLayout) */}
//                 <Route element={<MainLayout />}>
//                     <Route path="/" element={<Home />} />
//                     <Route path="/about" element={<About />} />
//                     <Route path="/blog" element={<Blog />} />
//                     <Route path="/blog/:Id" element={<BlogDetails />} />
//                     <Route path="/cart" element={<Cart />} />
//                     <Route path="/sign-in" element={<Signin />} />
//                     <Route path="/my-address" element={<RequireAuth><Address /></RequireAuth>} />
//                     <Route path="/my-order" element={<RequireAuth><MyOrder /></RequireAuth>} />
//                     <Route path="/order-tracking" element={<OrderTracking />} />
//                     <Route path="/wishlist" element={<WishList />} />
//                     <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
//                     <Route path="/contact" element={<Contact />} />
//                     <Route path="/checkout" element={<Checkout />} />
//                     <Route path="/address" element={<RequireAuth><OrderAddress /></RequireAuth>} />
//                     <Route path="/payment" element={<RequireAuth><Payments /></RequireAuth>} />
//                     <Route path="/order-confirm" element={<RequireAuth><OrderConfirm /></RequireAuth>} />
//                     <Route path="/menu" element={<Menu />} />
//                     <Route path="/product-detail" element={<ProductDetails />} />
//                 </Route>

//                 <Route element={<FooterLayout />}>
//                     <Route path="/support" element={<Support />} />
//                     <Route path="/partner" element={<Partner />} />
//                 </Route>

//                 <Route path="*" element={<NotFound />} />
//             </Routes>
//         </>
//     );
// };

// export default AppRouter;
